import React from 'react';
import { IconProps } from '../IconProps';

export interface AlertIconProps extends IconProps {
	color?: string;
}

export const SettingNoteWarningAlert: React.FC<AlertIconProps> = ({
	width = 16,
	height = 16,
	color = '#D15700',
	className,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.98905 0.00178764C5.85163 0.0367785 3.81383 0.911494 2.31618 2.43685C0.802084 3.94423 -0.033681 6.00266 0.00104023 8.13887C-0.00144305 10.2253 0.826648 12.227 2.30249 13.7019C3.77832 15.1768 5.78053 16.0037 7.86706 16H8.00972C12.4615 15.9542 16.036 12.3133 15.9997 7.86156C16.0047 5.74924 15.1574 3.7242 13.6496 2.2448C12.1418 0.765403 10.101 -0.0432799 7.98905 0.00178764ZM7.00047 11.0285C6.99076 10.7645 7.08765 10.5077 7.26933 10.3158C7.45101 10.124 7.70221 10.0133 7.96639 10.0087H7.98438C8.53102 10.0097 8.97923 10.4423 8.99963 10.9885C9.00953 11.2526 8.9127 11.5096 8.73098 11.7014C8.54926 11.8933 8.29795 12.004 8.03371 12.0084H8.01572C7.46936 12.0067 7.02155 11.5745 7.00047 11.0285ZM7.33377 8.33418V4.33463C7.33377 3.96648 7.63222 3.66804 8.00038 3.66804C8.36854 3.66804 8.667 3.96648 8.667 4.33463V8.33418C8.667 8.70233 8.36854 9.00077 8.00038 9.00077C7.63222 9.00077 7.33377 8.70233 7.33377 8.33418Z"
				fill={color}
			/>
		</svg>
	);
};

export const SettingNoteDisabledStatusIcon: React.FC<AlertIconProps> = ({
	width = 16,
	height = 16,
	color = '#767676',
	className,
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M6.96526 8.18517C7.04626 8.05118 7.14313 7.92662 7.25393 7.81397C7.32458 7.74184 7.35647 7.64238 7.34029 7.54459C7.32412 7.4468 7.26171 7.36171 7.17126 7.31413C6.44674 6.9276 5.63214 6.72329 4.80326 6.72021C2.59597 6.72993 0.653387 8.12054 0.0139262 10.1487C-0.0161817 10.2455 0.00313217 10.3503 0.0660223 10.4314C0.128912 10.5124 0.227987 10.5602 0.33326 10.5602H6.56526C6.67896 10.5604 6.7849 10.5049 6.84631 10.413C6.90772 10.3212 6.91612 10.2056 6.86859 10.1065C6.57224 9.48927 6.60832 8.77207 6.96526 8.18517Z"
				fill={color}
			/>
			<path
				d="M4.66569 6.08C6.41459 6.08 7.83236 4.71895 7.83236 3.04C7.83236 1.36105 6.41459 0 4.66569 0C2.91679 0 1.49902 1.36105 1.49902 3.04C1.49902 4.71895 2.91679 6.08 4.66569 6.08Z"
				fill={color}
			/>
			<path
				d="M11.832 11.8599C12.3843 11.8599 12.832 11.4301 12.832 10.8999C12.832 10.3697 12.3843 9.93994 11.832 9.93994C11.2797 9.93994 10.832 10.3697 10.832 10.8999C10.832 11.4301 11.2797 11.8599 11.832 11.8599Z"
				fill={color}
			/>
			<path
				d="M11.832 6.43994C12.3538 6.44004 12.8138 6.76811 12.9648 7.24756L13.248 8.13916C13.2939 8.28463 13.4491 8.37171 13.6035 8.33838L14.5439 8.12939C15.0525 8.01873 15.5768 8.23856 15.8369 8.67236C16.0971 9.10619 16.0318 9.65245 15.6768 10.019L15.0195 10.6997C14.9117 10.8129 14.9117 10.9869 15.0195 11.1001L15.6777 11.7808C16.0328 12.1474 16.098 12.6936 15.8379 13.1274C15.5778 13.5611 15.0533 13.7809 14.5449 13.6704L13.6035 13.4614C13.449 13.428 13.2934 13.5149 13.248 13.6606L12.9658 14.5522C12.8155 15.0325 12.3544 15.3608 11.832 15.3608C11.3099 15.3607 10.8495 15.0323 10.6992 14.5522L10.416 13.6606C10.3701 13.5155 10.2158 13.4287 10.0615 13.4614L9.12012 13.6704C8.61171 13.7809 8.08727 13.5611 7.82715 13.1274C7.56699 12.6936 7.63223 12.1474 7.9873 11.7808L8.64551 11.1001C8.75339 10.9869 8.75339 10.8129 8.64551 10.6997L7.9873 10.0181C7.63223 9.65147 7.56699 9.10522 7.82715 8.67139C8.08729 8.23776 8.61175 8.0179 9.12012 8.12842L10.0605 8.33838C10.2149 8.37132 10.37 8.28443 10.416 8.13916L10.6982 7.24756C10.8493 6.76795 11.3101 6.43994 11.832 6.43994ZM11.832 8.97998C10.7275 8.97998 9.83203 9.83952 9.83203 10.8999C9.83208 11.9603 10.7275 12.8198 11.832 12.8198C12.9363 12.8196 13.832 11.9601 13.832 10.8999C13.832 9.83967 12.9364 8.98023 11.832 8.97998Z"
				fill={color}
			/>
		</svg>
	);
};

export const ErrorAlertIcon: React.FC<AlertIconProps> = ({
	className,
	width = 16,
	height = 16,
	color = '#AB0000',
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.5953 7.02361L8.97619 0.404346C8.43691 -0.134782 7.56274 -0.134782 7.02346 0.404346L0.404338 7.0243C-0.134779 7.56359 -0.134779 8.43779 0.404338 8.97708L7.02346 15.5957C7.56274 16.1348 8.43691 16.1348 8.97619 15.5957L15.5953 8.97708C15.8544 8.71807 16 8.36671 16 8.00035C16 7.63398 15.8544 7.28262 15.5953 7.02361ZM7.35628 4.14486C7.35628 3.7635 7.66543 3.45435 8.04678 3.45435C8.42813 3.45435 8.73728 3.7635 8.73728 4.14486V8.28794C8.73728 8.6693 8.42813 8.97846 8.04678 8.97846C7.66543 8.97846 7.35628 8.6693 7.35628 8.28794V4.14486ZM8.082 12.0927H8.06266C7.49699 12.0905 7.03355 11.6429 7.01172 11.0776C7.00148 10.8042 7.10169 10.5381 7.28977 10.3394C7.47785 10.1406 7.73799 10.026 8.01157 10.0211H8.0309C8.59686 10.0226 9.06072 10.4706 9.08184 11.0362C9.09208 11.3096 8.99188 11.5757 8.8038 11.7744C8.61571 11.9732 8.35558 12.0879 8.082 12.0927Z"
				fill={color}
			/>
		</svg>
	);
};

export const InfoAlertIcon: React.FC<AlertIconProps> = ({
	className,
	width = 16,
	height = 16,
	color = '#0045DB',
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C15.9952 3.5837 12.4163 0.00477657 8 0ZM8.16667 3.33333C8.71895 3.33333 9.16667 3.78105 9.16667 4.33333C9.16667 4.88562 8.71895 5.33333 8.16667 5.33333C7.61438 5.33333 7.16667 4.88562 7.16667 4.33333C7.16667 3.78105 7.61438 3.33333 8.16667 3.33333ZM9.66667 12.3333H7C6.63181 12.3333 6.33333 12.0349 6.33333 11.6667C6.33333 11.2985 6.63181 11 7 11H7.5C7.59205 11 7.66667 10.9254 7.66667 10.8333V7.83333C7.66667 7.74129 7.59205 7.66667 7.5 7.66667H7C6.63181 7.66667 6.33333 7.36819 6.33333 7C6.33333 6.63181 6.63181 6.33333 7 6.33333H7.66667C8.40305 6.33333 9 6.93029 9 7.66667V10.8333C9 10.9254 9.07462 11 9.16667 11H9.66667C10.0349 11 10.3333 11.2985 10.3333 11.6667C10.3333 12.0349 10.0349 12.3333 9.66667 12.3333Z"
				fill={color}
			/>
		</svg>
	);
};

export const WarningAlertIcon: React.FC<AlertIconProps> = ({
	className,
	width = 16,
	height = 16,
	color = '#D15700',
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.839 13.6118L9.24928 1.08532C9.00587 0.622951 8.52477 0.333252 8.00035 0.333252C7.47593 0.333252 6.99484 0.622951 6.75142 1.08532L0.160976 13.6118C-0.0679887 14.0469 -0.051781 14.5695 0.203711 14.9897C0.459202 15.41 0.916799 15.6666 1.41026 15.6666H14.5897C15.0832 15.6666 15.5408 15.41 15.7963 14.9897C16.0518 14.5695 16.068 14.0469 15.839 13.6118ZM7.29499 5.48749C7.29499 5.09991 7.61063 4.78572 8 4.78572C8.38937 4.78572 8.70501 5.09991 8.70501 5.48749V9.69808C8.70501 10.0857 8.38937 10.3998 8 10.3998C7.61063 10.3998 7.29499 10.0857 7.29499 9.69808V5.48749ZM8.03525 13.5648H8.01551C7.43781 13.563 6.96441 13.1078 6.94248 12.5332C6.93222 12.2554 7.0346 11.9851 7.22659 11.7831C7.41858 11.5812 7.68407 11.4646 7.96334 11.4595H7.98308C8.56069 11.4602 9.03482 11.9145 9.05752 12.489C9.06856 12.7675 8.96632 13.0386 8.77392 13.2411C8.58151 13.4436 8.31521 13.5603 8.03525 13.5648Z"
				fill={color}
			/>
		</svg>
	);
};

export const CheckCircleIcon: React.FC<AlertIconProps> = ({
	className,
	width = 16,
	height = 16,
	color = '#4A9912',
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C15.9949 3.58385 12.4161 0.00514317 8 0ZM12.618 5.46667L8.05467 11.6593C7.94584 11.8037 7.78355 11.8983 7.60428 11.9219C7.42501 11.9455 7.24379 11.896 7.10133 11.7847L3.84267 9.17933C3.55511 8.94921 3.50855 8.52956 3.73867 8.242C3.96879 7.95444 4.38844 7.90788 4.676 8.138L7.39333 10.312L11.5447 4.678C11.6808 4.47373 11.9182 4.36079 12.1625 4.38403C12.4069 4.40726 12.6187 4.56291 12.7139 4.78918C12.8091 5.01545 12.7723 5.27572 12.618 5.46667Z"
				fill={color}
			/>
		</svg>
	);
};
